import { useEffect } from "react"
import { BeforeRoute } from "slot-definitions"

let cleared = false

function RegistrationRedirectCleanup() {
    useEffect(() => {
        if (cleared) return
        cleared = true
        sessionStorage.removeItem("registration-redirect")
    }, [])
    return null
}

BeforeRoute.plug(<RegistrationRedirectCleanup />)
